export const T = {
  en_GB: {
    line: (p: { line: number; reason: string }) => `Line ${p.line}: ${p.reason}`,
    errors: {
      syntax: (detail: string) => `CSV parse error: ${detail}`,
      header: (got: string) =>
        `First row must be a header: "Date;Value" or "Date,Value". Got: "${got}"`,
      missingValue: "Missing value. Expected: date;value or date,value (e.g., 2026-01-06;102.5)",
      invalidDate: (value: string) => `Invalid date "${value}". Expected: yyyy-mm-dd or dd/mm/yyyy`,
      invalidValue: (value: string) => `Invalid value "${value}". Expected a number`,
      notIncreasing: (p: { date: string; previous: string }) =>
        `Dates must be in increasing order. "${p.date}" must be after "${p.previous}"`,
      noData: "No data found. Enter at least one date;value pair",
    },
  },
  nb_NO: {
    line: (p: { line: number; reason: string }) => `Linje ${p.line}: ${p.reason}`,
    errors: {
      syntax: (detail: string) => `Feil ved lesing av CSV: ${detail}`,
      header: (got: string) =>
        `Første rad må være en overskrift: "Date;Value" eller "Date,Value". Fikk: "${got}"`,
      missingValue:
        "Verdi mangler. Forventet: dato;verdi eller dato,verdi (f.eks. 2026-01-06;102.5)",
      invalidDate: (value: string) =>
        `Ugyldig dato "${value}". Forventet: åååå-mm-dd eller dd/mm/åååå`,
      invalidValue: (value: string) => `Ugyldig verdi "${value}". Forventet et tall`,
      notIncreasing: (p: { date: string; previous: string }) =>
        `Datoene må være i stigende rekkefølge. "${p.date}" må komme etter "${p.previous}"`,
      noData: "Ingen data funnet. Skriv inn minst ett dato;verdi-par",
    },
  },
} as const;
